import(/* webpackMode: "eager", webpackExports: ["TeamsListSkeleton"] */ "/home/danielwong/facility-calcom/cal2/apps/web/app/(use-page-wrapper)/(main-nav)/teams/skeleton.tsx");
